import { ChatMessage } from '@/machines/chatMachine.types';
import { FeedbackResponse, FeedbackType, HistoryMessage } from '@/apiTypes/AiTypes';

export const mapHistoryToChatMessages = (historyMessages: HistoryMessage[]): ChatMessage[] => {
    return historyMessages
        .filter(msg => msg.role !== 'system')
        .sort((a, b) => a.sequenceNumber - b.sequenceNumber)
        .map(msg => ({
            id: msg.id,
            role: msg.role as 'user' | 'assistant',
            content: msg.content,
            serverMessageId: msg.role === 'assistant' ? msg.id : undefined,
        }));
};

export const mapFeedbackToRecord = (feedback: FeedbackResponse[]): Record<string, { id: string; type: FeedbackType }> => {
    return feedback.reduce((acc, fb) => {
        acc[fb.messageId] = { type: fb.feedbackType, id: fb.id };
        return acc;
    }, {} as Record<string, { id: string; type: FeedbackType }>);
};
